import axios from "axios";

import {
  onRequest,
  onRequestError,
  onResponse,
  onResponseError,
} from "./interceptors";

export const baseURL = process.env.REACT_APP_API_BASEURL + `api/v1/`;
const axiosApi = axios.create({
  baseURL,
  timeout: 1000 * 20,
});

// Add a request interceptor
axiosApi.interceptors.request.use(onRequest, onRequestError);

// Add a response interceptor
axiosApi.interceptors.response.use(onResponse, onResponseError);

export default axiosApi;

export async function get(url, data, config = {}) {
  return await axiosApi
    .get(url, { params: { ...data } }, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data);
}

export async function update(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
